<template>
  <EmsLayout>
    <EmsMonitor />
  </EmsLayout>
</template>

<script>
  import EmsLayout from '../layout/EmsLayout.vue';
  import EmsMonitor from '../emsMonitor/EmsMonitor.vue';

  export default {
    name: 'EmsHome',
    components: {
      EmsLayout,
      EmsMonitor,
    },
  };
</script>
